import React, { ReactElement, ReactPortal } from 'react'
import ReactDOM from 'react-dom'
import { Transition } from 'react-transition-group'
import { Animation, AnimationFixed } from '@navent-jobs/ui-kit/components/animation'
import { ModalBackdrop, ModalComponent, ModalDialog, ModalContent, ModalBody } from './mixins'

export interface ModalProps {
  animation?: string
  height?: number
  children: ReactElement
  visible: boolean
  onClose: Function
  width?: number
  color?: string
}

const BottomSidebar = ({
  height,
  children,
  visible,
  onClose,
  width,
  animation,
  color,
}: ModalProps): ReactPortal | null => {
  const modalDOM = document.getElementById('modal') as HTMLElement
  return ReactDOM.createPortal(
    <Transition in={visible} timeout={250} mountOnEnter>
      {state => (
        <>
          <AnimationFixed onClick={onClose} name={animation} className={`animation-${state}`} mountOnEnter exit={false}>
            <ModalComponent>
              <ModalDialog width={width} height={height}>
                <ModalContent color={color}>
                  <ModalBody>{children || null}</ModalBody>
                </ModalContent>
              </ModalDialog>
            </ModalComponent>
          </AnimationFixed>
          <Animation name="fadeIn" className={`animation-${state}`}>
            <ModalBackdrop />
          </Animation>
        </>
      )}
    </Transition>,
    modalDOM
  )
}

export default BottomSidebar
